import React from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import Loading from "components/shared-components/Loading";

interface CompareChartProps {
  title: string;
  options: ApexOptions;
  series: any[];
  loading: boolean;
  noDataMessage?: string;
  height?: number;
}

const CompareChart: React.FC<CompareChartProps> = ({
  title,
  options,
  series,
  loading,
  noDataMessage = "No data available for the selected period",
  height = 400
}) => {
  const renderChartContent = () => {
    if (loading) {
      return (
        <VuiBox display="flex" justifyContent="center" alignItems="center" height={`${height}px`}>
          <Loading />
        </VuiBox>
      );
    }

    if (!series.length || series.every(s => !s.data || s.data.length === 0)) {
      return (
        <VuiBox display="flex" justifyContent="center" alignItems="center" height={`${height}px`}>
          <VuiTypography variant="button" color="text">
            {noDataMessage}
          </VuiTypography>
        </VuiBox>
      );
    }

    return (
      <Chart
        options={options}
        series={series}
        type="line"
        width="100%"
        height={height}
      />
    );
  };

  return (
    <VuiBox mt={3}>
      {renderChartContent()}
    </VuiBox>
  );
};

export default CompareChart;
